import {
  useForm,
  FormProvider,
  useFormContext,
  Controller as FormInputController,
  useFieldArray,
  useWatch,
  UseFormMethods as _UseFormMethods,
} from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'

export type UseFormMethods<T> = _UseFormMethods<T>
export type FormInputControllerProps = React.ComponentProps<typeof FormInputController>

export {
  useForm,
  FormProvider,
  useFormContext,
  FormInputController,
  useFieldArray,
  useWatch,
  yupResolver,
}

export default useForm
